"use client";

import type { PagePathType } from "@/shared/config/app";
import {
  SEARCH_PAGE_VIEW_BACKLOG_EXTRACT,
  SEARCH_PAGE_VIEW_STUDIO_CHECK,
  SEARCH_PAGE_VIEW_STUDIO_PRINT,
  SEARCH_PAGE_VIEW_STUDIO_SELECT,
  type SearchPageView,
  type SearchIndexName,
  type SearchStateKey,
} from "./keys";

export type { SearchPageView } from "./keys";

type SearchPageMeta = {
  searchStateKey: SearchStateKey;
  configKey: SearchIndexName;
  breadcrumbPage: PagePathType;
  showPerspectiveBreadcrumb: boolean;
  showTargetFocusSection: boolean;
  useTallDialog: boolean;
};

export const SEARCH_PAGE_META: Record<SearchPageView, SearchPageMeta> = {
  [SEARCH_PAGE_VIEW_BACKLOG_EXTRACT]: {
    searchStateKey: "backlog",
    configKey: "origins",
    breadcrumbPage: "backlog",
    showPerspectiveBreadcrumb: false,
    showTargetFocusSection: false,
    useTallDialog: false,
  },
  [SEARCH_PAGE_VIEW_STUDIO_CHECK]: {
    searchStateKey: "check",
    configKey: "suggested_thoughts",
    breadcrumbPage: "studio",
    showPerspectiveBreadcrumb: true,
    showTargetFocusSection: true,
    useTallDialog: true,
  },
  [SEARCH_PAGE_VIEW_STUDIO_SELECT]: {
    searchStateKey: "select",
    configKey: "thoughts",
    breadcrumbPage: "studio",
    showPerspectiveBreadcrumb: true,
    showTargetFocusSection: true,
    useTallDialog: true,
  },
  [SEARCH_PAGE_VIEW_STUDIO_PRINT]: {
    searchStateKey: "select",
    configKey: "thoughts",
    breadcrumbPage: "studio",
    showPerspectiveBreadcrumb: true,
    showTargetFocusSection: true,
    useTallDialog: true,
  },
};

export function resolveSearchPageView({
  pathname,
  activeStudioContent,
  activeStudioExportLock,
}: {
  pathname: string | null;
  activeStudioContent: string;
  activeStudioExportLock: boolean;
}): SearchPageView {
  if (pathname?.includes("/backlog")) return "backlog_extract";
  if (pathname?.includes("/studio") && activeStudioExportLock) {
    return "studio_print";
  }
  if (pathname?.includes("/studio")) {
    return activeStudioContent === "suggested"
      ? "studio_check"
      : "studio_select";
  }

  return "studio_select";
}
